import { FC } from 'react';

import ReactModal from 'react-modal';

import { Container } from './styles';

interface ModalProps {
  isOpen: boolean;
  maxWidthStyled?: number | string;
  maxHeightStyled?: number | string;
}

const Modal: FC<ModalProps> = ({
  isOpen,
  children,
  maxWidthStyled,
  maxHeightStyled,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      ariaHideApp={false}
      style={{
        content: {
          overflow: 'auto',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          background: '#FFFEFC',
          color: '#000000',
          borderRadius: '0.8rem',
          maxWidth: maxWidthStyled ?? '73.4rem',
          width: '100%',
          maxHeight: maxHeightStyled ?? '73.6rem',
          height: '100%',
          // border: 'none',
          animation: 'bounceIn 1s ease-in-out',
          boxShadow: '#0000000F 0px 0.3rem 0.6rem',
          padding: 0,
        },
        overlay: {
          background: '#232323aa',
          zIndex: 99,
          transition: 'none',
        },
      }}
    >
      <Container>{children}</Container>
    </ReactModal>
  );
};

export default Modal;
